import { Navigate, Outlet } from 'react-router';
import { useAuthStore } from '@/stores/authStore';
import { getAdminHomeRoute, isAdminRole, ROLES, ROUTES } from '@/lib/constants';

/**
 * Guards practitioner-only pages. Mirrors AdminRoute, inverted: the API endpoints
 * behind these pages are `[Authorize(Roles = "User")]`, so an admin hitting them
 * would only get a 403.
 */
export function ProviderRoute() {
  const { user } = useAuthStore();

  if (!user) {
    return <Navigate to={ROUTES.LOGIN} replace />;
  }

  if (Number(user.roleId) !== ROLES.USER) {
    return <Navigate to={isAdminRole(user.roleId) ? getAdminHomeRoute(user.roleId) : ROUTES.LOGIN} replace />;
  }

  return <Outlet />;
}
